import { useState, useEffect } from "react";
import {
  MultiSelect,
  MultiSelectContent,
  MultiSelectItem,
  MultiSelectTrigger,
} from "../ui/multiselect";
import { Input } from "../ui/input";

export const FilterMultiSelect = ({
  label,
  keyName,
  value,
  onValueChange,
  options,
  openDropdownKey,
  setOpenDropdownKey,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(
    options.filter((opt) => opt !== null && opt !== undefined)
  );

  // Debounce filter logic
  useEffect(() => {
    const handler = setTimeout(() => {
      const query = searchQuery.trim().toLowerCase();
      setFilteredOptions(
        options.filter(
          (option) => option && option.toString().toLowerCase().includes(query)
        )
      );
    }, 300); // 300ms debounce

    return () => clearTimeout(handler);
  }, [searchQuery, options]);

  return (
    <div key={keyName} className="space-y-2">
      <label className="font-medium">{label}</label>
      <MultiSelect
        value={value}
        onValueChange={onValueChange}
        dropdownKey={keyName}
        openDropdownKey={openDropdownKey}
        setOpenDropdownKey={setOpenDropdownKey}
      >
        <MultiSelectTrigger>
          {value?.length > 0 ? value.join(", ") : `Select ${label}`}
        </MultiSelectTrigger>

        <MultiSelectContent className="bg-white max-h-60">
          <Input
            type="text"
            placeholder={`Search ${label}`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="h-8"
          />
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, idx) => (
              <MultiSelectItem key={`${option}-${idx}`} value={option}>
                {option}
              </MultiSelectItem>
            ))
          ) : (
            <div className="px-4 py-2 text-sm text-gray-500">
              No matching results
            </div>
          )}
        </MultiSelectContent>
      </MultiSelect>
    </div>
  );
};
